export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./student.vue?vue&type=template&id=5d0f87f8&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/student.vue?vue&type=template&id=5d0f87f8&
// module id = null
// module chunks = 